/* global localStorage alert */
import firebase from '../helpers/firebase';
import { TABLE_NAME } from '../helpers/constants';
const db = firebase.database();
const firebaseAuth = firebase.auth();

class Auth {
  static authenticate() {
    const provider = new firebase.auth.GoogleAuthProvider();
    return firebaseAuth.signInWithPopup(provider).then((result) => {
      // The signed-in user info.
      const user = result.user;

      if (!/@roamandwander.com$/.test(user.email)) {
        throw Error('Must use @roamandwander.com account');
      }

      return db.ref(TABLE_NAME.USERS).child(user.uid).update({
        name: user.displayName,
        photoURL: user.photoURL,
        email: user.email,
        id: user.uid,
      });
    });
  }

  static signOut(cb) {
    firebase.auth().signOut().then(function() {
      localStorage.removeItem('currentUser');
      window.location.href = '/';
    }, function(error) {
      alert('Sign out error: ' + JSON.stringify(error));
    });
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/helpers/Auth.js